var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let ComponentToolbarMenuDivider = class ComponentToolbarMenuDivider extends LitElement {
    constructor() {
        super(...arguments);
        this.vertical = true;
    }
    render() {
        return html `<div
      class="divider-container ${this.vertical ? 'vertical' : 'horizontal'}"
    >
      <div class="divider"></div>
    </div>`;
    }
};
ComponentToolbarMenuDivider.styles = css `
    .divider-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .divider {
      background-color: var(--affine-border-color);
    }

    .vertical {
      width: 4px;
      height: 100%;
    }

    .vertical .divider {
      width: 1px;
      height: 100%;
    }

    .horizontal {
      width: 100%;
      height: 4px;
    }

    .horizontal .divider {
      width: 100%;
      height: 1px;
    }
  `;
__decorate([
    property({ type: Boolean })
], ComponentToolbarMenuDivider.prototype, "vertical", void 0);
ComponentToolbarMenuDivider = __decorate([
    customElement('component-toolbar-menu-divider')
], ComponentToolbarMenuDivider);
export { ComponentToolbarMenuDivider };
//# sourceMappingURL=component-toolbar-menu-divider.js.map